import styled from '@emotion/styled';
import { emptyObject } from '@constants/empty';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Avatar from 'aquilla/core/atoms/Avatar';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AvatarWrapper = styled.div`
  width: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_6B};
  margin-right: ${Spacings.SPACING_2B};
  border-radius: 50%;
  overflow: hidden;
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledH5 = styled(Typography)`
  font-weight: ${Fonts.LIGHT};
  color: var(--color-text-secondary);
  margin-left: ${Spacings.SPACING_3};
`;

const StyledAvatar = styled(Avatar)`
  width: 24px;
  height: 24px;
`;

const getGameStateInfo = (state) => {
  if (state === 1) {
    return {
      gameState: 'Draw',
      color: 'var(--color-text-secondary)'
    };
  }

  if (state === 2) {
    return {
      gameState: 'Win',
      color: 'var(--color-i-accent-green)'
    };
  }

  return {
    gameState: 'Loss',
    color: 'var(--color-i-red)'
  };
};

const RatingPill = ({ rankInfo }) => {
  const { state, points, opponentUserFirstName, opponentUserAvatar } =
    rankInfo || emptyObject;
  const { gameState, color } = getGameStateInfo(state);

  return (
    <Wrapper className="rating-pill">
      <InfoWrapper>
        <AvatarWrapper>
          <StyledAvatar src={opponentUserAvatar} size={24} />
        </AvatarWrapper>
        <Typography variant="h6">{gameState}</Typography>{' '}
        <StyledH5 variant="h6">against {opponentUserFirstName}</StyledH5>
      </InfoWrapper>
      <Typography variant="h6" color={color}>
        {points > 0 ? '+' : ''}
        {points}
      </Typography>
    </Wrapper>
  );
};

export default RatingPill;
